// Per-language landing page metadata, derived from the existing locale files.
// Imported by both components/SEO.js (browser) and scripts/prerender-seo.js (build).

export function cleanDashes(text, cjk) {
  return String(text || '').replace(/\s*[—–]+\s*/g, cjk ? '，' : ', ').trim();
}

export function landingH1(lang, t) {
  if (lang.h1) return lang.h1;
  const parts = [t('v2.heroBefore'), t('v2.word1'), t('v2.heroAfter')].map((p) => String(p).trim());
  return lang.cjk ? parts.join('') : parts.join(' ');
}

export function landingTitle(lang, t) {
  const h1 = landingH1(lang, t).replace(/[.。।۔!?！]+$/u, '');
  return `${h1} | ${t('v2.chatTitle')}`;
}

export function landingDescription(lang, t) {
  return cleanDashes(t('v2.heroSubtitle'), lang.cjk);
}
